module.exports = __webpack_public_path__ + "static/media/pumaScreen.22f8af2c.jpg";